var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "menu" } }, [
    _c("div", { staticClass: "contentMenu" }, [
      _c("div", { ref: "scroll", attrs: { id: "scrollbar-container" } }, [
        _c(
          "ul",
          { staticClass: "nav tabsMenu" },
          [
            _vm._l(_vm.itemsEntries.slice(0, _vm.nbMainModules), function(ref) {
              var id = ref[0]
              var item = ref[1]
              return _c(
                "li",
                {
                  key: id,
                  staticClass: "menuli",
                  class: { hasSubMenu: item["sub"] },
                  attrs: { id: "menuli_" + id }
                },
                [
                  _c("menu-link", {
                    attrs: {
                      item: item,
                      itemId: id,
                      activeItem: _vm.activeItem
                    }
                  }),
                  _vm._v(" "),
                  !item["sub"] && item.id !== "dashboard"
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "menu-label typographies-paragraph-small-semibold"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.txt) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item["sub"]
                    ? _c(
                        "ul",
                        {
                          staticClass: "hidden tabSubmenu",
                          style:
                            id === "ecommerce"
                              ? "{overflow-y: scroll; max-height: 200px; width: 256px;}"
                              : "",
                          attrs: { id: "__menu__" + id }
                        },
                        [
                          _c("li", { staticClass: "tabSumenutitle_title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(item["txt"] ? item["txt"] : "") +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(item["sub"], function(sub, subItemId) {
                            return _c(
                              "li",
                              {
                                key: subItemId,
                                class: sub["class"] ? sub["class"] : ""
                              },
                              [
                                !sub["class"] || sub["class"] !== "separator"
                                  ? [
                                      _c("menu-link", {
                                        attrs: {
                                          item: sub,
                                          activeItem: _vm.activeItem
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.itemsEntries.length > _vm.nbMainModules
              ? _c(
                  "el-collapse",
                  {
                    on: { change: _vm.onChangeCollapse },
                    model: {
                      value: _vm.activeName,
                      callback: function($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName"
                    }
                  },
                  [
                    _c(
                      "el-collapse-item",
                      {
                        attrs: { name: "1" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("i", {
                                    staticClass:
                                      "el-collapse-item__arrow el-icon-arrow-down"
                                  }),
                                  _vm._v(" "),
                                  _vm.fullMenu
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activeName === "1"
                                              ? _vm.$l10n.__("Moins")
                                              : _vm.$l10n.__("Plus")
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3387286378
                        )
                      },
                      [
                        _vm._v(" "),
                        _vm._l(
                          _vm.itemsEntries.slice(
                            _vm.nbMainModules,
                            _vm.itemsEntries.length
                          ),
                          function(ref) {
                            var id = ref[0]
                            var item = ref[1]
                            return _c(
                              "li",
                              {
                                key: id,
                                staticClass: "menuli",
                                class: { hasSubMenu: item["sub"] },
                                attrs: { id: "menuli_" + id }
                              },
                              [
                                _c("menu-link", {
                                  attrs: {
                                    item: item,
                                    itemId: id,
                                    activeItem: _vm.activeItem
                                  }
                                }),
                                _vm._v(" "),
                                !item["sub"] && item.id !== "dashboard"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "menu-label typographies-paragraph-small-semibold"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.txt) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item["sub"]
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass: "hidden tabSubmenu",
                                        style:
                                          id === "ecommerce"
                                            ? "{overflow-y: scroll; max-height: 200px; width: 256px;}"
                                            : "",
                                        attrs: { id: "__menu__" + id }
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass: "tabSumenutitle_title"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  item["txt"] ? item["txt"] : ""
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(item["sub"], function(
                                          sub,
                                          subItemId
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: subItemId,
                                              class: sub["class"]
                                                ? sub["class"]
                                                : ""
                                            },
                                            [
                                              !sub["class"] ||
                                              sub["class"] !== "separator"
                                                ? [
                                                    _c("menu-link", {
                                                      attrs: {
                                                        item: sub,
                                                        activeItem:
                                                          _vm.activeItem
                                                      }
                                                    })
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }